import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    getTeacherClasses,
    getPossibleClasses,
    addClassToTeacher,
    archiveTeacherClass,
} from '../../../redux';
import ClassTile from './ClassTile';
import { Link } from 'react-router-dom';
import AddClassForms from "./AddClassForms"
import Dialog from 'material-ui/Dialog';
import '../../Components/dashboard.css';

function ManageClasses (props) {
    const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);
    const [classToArchive, setClassToArchive] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // On hard refresh at `/manage/classes`, redux state is empty. Re-fetch here.
    useEffect(() => {
        const teacherId = props.user && props.user._id;
        const schoolId = props.user && props.user.school;
        if (teacherId) {
            props.getTeacherClasses(teacherId);
        }
        if (schoolId) {
            props.getPossibleClasses(schoolId);
        }
    }, [props.user]);

    const handleArchiveClick = (classObject) => {
        setClassToArchive(classObject);
        setArchiveDialogOpen(true);
    };

    const handleArchiveConfirm = () => {
        if (classToArchive) {
            props.archiveTeacherClass(props.user._id, classToArchive._id);
        }
        setArchiveDialogOpen(false);
        setClassToArchive(null);
    };

    const handleArchiveCancel = () => {
        setArchiveDialogOpen(false);
        setClassToArchive(null);
    };

    const filteredClasses = props.possibleClasses.filter(classObject => !props.user.classes.includes(classObject._id));

    return (
        <div className="dashboard">
            <Link to="/teacher" className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </Link>
            <div className="reviewHeaders" style={{ marginTop: "33px" }}>
                <h3 className="left" style={{ marginTop: "0px" }}>Active Classes</h3>
                <Link to="/manage/classes/archived" className="right actionButton" style={{ textDecoration: "none" }}>
                    View archived classes
                </Link>
            </div>
            <div className="tiles">
                {
                    props.teacherClasses && props.teacherClasses
                    .map((classObject, index) => {
                        return (
                            <ClassTile
                                key={index + classObject.name}
                                thisClassObject={classObject}
                                onArchiveClick={handleArchiveClick}
                            />
                        )
                    })
                }
            </div>

            <AddClassForms
                possibleClasses={props.possibleClasses}
                classOptions={filteredClasses}
                addClass={props.addClassToTeacher}
            />
            
            <Dialog open={archiveDialogOpen} onRequestClose={handleArchiveCancel}>
                <div>
                    <h3>Archive this class?</h3>
                    <p>Archived classes are hidden from students by default. You can restore them from Archived Classes.</p>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "20px 10px",
                            gap: "24px",
                        }}
                    >
                        <button onClick={handleArchiveCancel} className="actionButton">
                            Cancel
                        </button>
                        <button className="actionButton" onClick={handleArchiveConfirm}>
                            Archive Class
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(state => state.root, {
    getTeacherClasses,
    getPossibleClasses,
    addClassToTeacher,
    archiveTeacherClass,
})(ManageClasses);
